import React from 'react'
import PropTypes from 'prop-types'
import Icon from 'components/Icon'
import classnames from 'classnames'
import partial from 'utils/partial'

export default class Select extends React.Component {
  static propTypes = {
    value: PropTypes.string,
    empty: PropTypes.string,
    options: PropTypes.array,
    className: PropTypes.string,
    disabled: PropTypes.bool,
    onSelect: PropTypes.func,
    withIcon: PropTypes.bool,
    isChannelType: PropTypes.bool
  }

  constructor(props) {
    super(props)
    this.state = {
      opened: false
    }
  }

  componentWillUpdate(props, state) {
    if (state.opened) {
      document.addEventListener('click', this.hideList)
    } else {
      document.removeEventListener('click', this.hideList)
    }
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.hideList)
  }

  render() {
    const {disabled, className} = this.props
    if (disabled) return null

    const {opened} = this.state
    const classNames = classnames('channel-select_item', className, {
      'is-opened': opened
    })

    return (
      <div className={classNames} onClick={this.onClick}>
        {this.renderSelectedValue()}
        {this.renderDropdown()}
      </div>
    )
  }

  renderSelectedValue() {
    const {value} = this.props

    return (
      <div className='channel-select_item_label'>
        {this.renderItem(this.findItemByValue(value))}
        <Icon
          className='channel-select_item_label_icon'
          name='chevron'
          size='10px'
        />
      </div>
    )
  }

  renderDropdown() {
    return (
      <div className='channel-select_dropdown'>
        {this.renderClearValue()}
        {this.renderList()}
      </div>
    )
  }

  renderClearValue() {
    const {value} = this.props
    const item = this.findItemByValue(value)
    const {opened} = this.state
    if (!opened || !item) return null

    return (
      <div className='channel-select_item_clear' onClick={this.onClear}>
        <Icon name='cross' size='10px' />
        <span className='channel-select_item_clear_text'>Clear selection</span>
      </div>
    )
  }

  renderList() {
    const {options} = this.props
    const {opened} = this.state
    if (!opened) return null

    return (
      <div className='channel-select_item_list'>
        {options.map(option => this.renderItem(option))}
      </div>
    )
  }

  renderItem(option) {
    const {empty, withIcon, isChannelType} = this.props
    const {disabled, id} = option || {}
    const classNames = classnames('channel-select_option', {
      'is-empty': !option,
      'is-disabled': disabled,
      'with-icon': withIcon && option,
      [`is-${id}`]: !withIcon && option && !isChannelType
    })
    const onClick = option ? partial(this.onItemClick, option) : null

    return (
      <div
        className={classNames}
        onClick={onClick}
        key={option ? option.id : 'empty_option'}
      >
        {this.renderIcon(option)}
        {option ? option.label : empty}
      </div>
    )
  }

  renderIcon(item) {
    const {withIcon} = this.props
    if (!withIcon || !item) return null

    const {id} = item
    return (
      <Icon
        className='channel-select_option_icon'
        name={`channel-${id}`}
        size='12px'
      />
    )
  }

  onClick = e => {
    e.stopPropagation()
    const {disabled} = this.props
    if (disabled) return false

    this.setState({
      opened: !this.state.opened
    })
  }

  onClear = e => {
    const {onSelect} = this.props
    onSelect && onSelect(null)
  }

  onItemClick = (option, item) => {
    if (item.disabled) return null

    const {onSelect} = this.props
    onSelect && onSelect(option)
  }

  hideList = () => {
    this.setState({
      opened: false
    })
  }

  findItemByValue(value) {
    const {options} = this.props
    if (!value) return null

    return options.find(option => option.id === value) || null
  }
}



// WEBPACK FOOTER //
// ./client/components/ChannelSelect/Select.js